import '../styles/globals.css'
import 'react-tooltip/dist/react-tooltip.css'
import type { AppProps } from 'next/app'

function MyApp({ Component, pageProps }: AppProps) {
  return <Component {...pageProps} />
}

export default MyApp
